import { bbox } from "@turf/turf";
import type { Geometry } from "geojson";
import type { MapRef } from "react-map-gl/maplibre";
import type { GeoJSONFeatureCollection } from "../clip/clip-ui/models";
import { getMapFitPadding } from "@/utils/map-padding";

const zoomToFeatureCollection = (
  mapRef: React.Ref<MapRef>,
  fc: GeoJSONFeatureCollection,
  padding = 200,
) => {
  if (fc.features.length === 0) return;
  const [minLng, minLat, maxLng, maxLat] = bbox(fc);
  if (!mapRef || typeof mapRef === "function" || !mapRef.current) return;
  const map = mapRef.current;
  map.fitBounds(
    [
      [minLng, minLat],
      [maxLng, maxLat],
    ],
    { padding: getMapFitPadding(map.getContainer(), padding), duration: 1000 },
  );
};

const zoomToFeature = (
  mapRef: React.Ref<MapRef>,
  geometry: Geometry,
  padding = 200,
) => {
  const [minLng, minLat, maxLng, maxLat] = bbox(geometry);
  if (!mapRef || typeof mapRef === "function" || !mapRef.current) return;
  const map = mapRef.current;
  map.fitBounds(
    [
      [minLng, minLat],
      [maxLng, maxLat],
    ],
    { padding: getMapFitPadding(map.getContainer(), padding), duration: 1000 },
  );
};

export { zoomToFeature, zoomToFeatureCollection };
